import location from './location';
import widgetInfo from './widgetInfo';

const root = {
	location,
	widgetInfo
};

export default root;
